import React from 'react';
import GuageIcon from '../../svgs/horticulture/gauge-icon.svg';
import CalendarIcon from '../../svgs/horticulture/calendar-with-a-clock-time-tools.svg';
import PhoneIcon from '../../svgs/horticulture/phone-icon.svg';
import './badges.css';

function Badge({ children, style, link }) {
  return (
    <a href={link} className="badge" style={style}>
      {children}
    </a>
  );
}

export default function Badges() {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <Badge
        link="#monitor"
        style={{ background: '#006080', color: 'white', marginLeft: 0 }}
      >
        <GuageIcon className="badge-icon" />
        Monitor
      </Badge>
      <Badge link="#control" style={{ background: '#26734d', color: 'white' }}>
        <CalendarIcon className="badge-icon" />
        Control
      </Badge>
      <Badge link="#notify" style={{ background: '#804d00', color: 'white' }}>
        <PhoneIcon className="badge-icon" />
        Notify
      </Badge>
    </div>
  );
}
